import { FONT_URL } from '../config';

const CSS_ID = 'ondiem-pro-availability-styles';
const FONT_LINK_ID = 'ondiem-pro-availability-fonts';
let stylesInjected = false;
let fontInjected = false;

/**
 * Injects CSS into the document head if not already injected
 * Also injects Montserrat font from Google Fonts
 * Idempotent - safe to call multiple times
 */
export function injectCSS(css: string): void {
  // Inject Montserrat font link (if not already injected)
  if (!fontInjected) {
    if (!document.getElementById(FONT_LINK_ID)) {
      const fontLink = document.createElement('link');
      fontLink.id = FONT_LINK_ID;
      fontLink.rel = 'stylesheet';
      fontLink.href = FONT_URL;
      document.head.appendChild(fontLink);
    }
    fontInjected = true;
  }

  // Inject CSS styles
  if (stylesInjected) {
    return;
  }

  // Check if styles already exist (in case of multiple widget instances)
  if (document.getElementById(CSS_ID)) {
    stylesInjected = true;
    return;
  }

  const style = document.createElement('style');
  style.id = CSS_ID;
  style.textContent = css;
  document.head.appendChild(style);
  stylesInjected = true;
}
